import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../../../util/reactIntl';
import classNames from 'classnames';
import css from './SectionClientFeatures.module.css';
import gear from '../../../../../assets/images/gear-image.22b3aaa3.png';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';

const MOBILE_BREAKPOINT = 768; // Search is in modal on mobile layout

const featureList = [
  {
    icon: <IconCard brand="project" />,
    title: "1. Create a project",
    description: "Get your project noticed by professionals."
  },
  {
    icon: <IconCard brand="matched" />,
    title: "2. Get matched",
    description: "We made the process of getting matched easy!"
  },
  {
    icon: <IconCard brand="quotes" />,
    title: "3. Receive quotes",
    description: "Invite matched professionals to bid on your project."
  },
  {
    icon: <IconCard brand="chat" />,
    title: "4. Chat with pros",
    description: "Get started on your project and see it start to finish."
  },
  {
    icon: <IconCard brand="management" />,
    title: "5. Booking management",
    description: "Easily accept or decline your quote requests."
  },
  {
    icon: <IconCard brand="review" />,
    title: "6. Leave review",
    description: "Let others know about your experience!"
  },
]

const SectionClientFeatures = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.subTitle}>
        For clients
      </div>
      <div className={css.title}>
        How to get equipped
      </div>
      <p className={css.text}>
        Our step-by-step process guides your project from start to finish.
      </p>
      <div className={css.cardsWrapper}>
        <img className={css.gearImage} src={gear} alt="Equipped" />
        <div className={css.cards}>
          {featureList.map((item, i) => {
            return (
              <div className={css.card} key={i}>
                <div className={css.iconWrapper}>{item.icon}</div>
                <div className={css.cardContent}>
                  <h2 className={css.cardTitle}>
                    {item.title}
                  </h2>
                  <p className={css.cardText}>
                    {item.description}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};

SectionClientFeatures.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionClientFeatures.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionClientFeatures;
